import { smart } from "webpack-merge";

export default {
  // 首页头部导航显示
  // nav鼠标滑入
  navShow: function () {
    $('.nav_a_show').mouseenter(function () {
      $('.nav_a_show').css({ 'transform': 'scale(1.2,1.2)', 'background': '#ed9d64' })
      $('.nav_show').css('transform', 'scaleY(1)');
    })
  },
  // nav鼠标滑出
  navNone: function () {
    $('.nav_show').mouseleave(function () {
      $('.nav_show').css('transform', 'scaleY(0)');
      $('.noneShowH').css('display', 'none');
      $('.noneShowX').css('display', 'none');
    })
  },
  // nav弹出框选择
  navEgect: function () {
    $('.nav_show').mouseenter(function () {
      $('.nav_a_show').css({ 'transform': 'scale(1.2,1.2)', 'background': '#ed9d64' });
    })
  },
  // nav弹出框退出
  navQuit: function () {
    $('.nav_show').mouseleave(function () {
      $('.nav_a_show').css({ 'transform': 'scale(1,1)', 'background': 'none' });
      $('.nav_show_left').css('transform', 'scaleX(0)');
    })
  },
  // nav弹出框侧栏选择
  navLeftEgect: function () {
    $('.nav_show .leftShow').mouseenter(function () {
      $('.nav_show_left').css('transform', 'scaleX(1)');
      $(this).siblings().find($('.nav_show_left')).css('transform', 'scaleX(0)');
    })
  },
  // index-首页公示栏右侧图片展示
  IndexShow: function () {
    $('.bottomShowH').mouseenter(function () {
      $('.noneShowH').css('display', 'block');
      $('.noneShowX').css('display', 'none');
    })
    $('.bottomShowX').mouseenter(function () {
      $('.noneShowX').css('display', 'block');
      $('.noneShowH').css('display', 'none');
    })
  },

  // IndexMajor——首页四大专业版块
  // Major滑入
  MajorShow: function () {
    $('.MajorTop').mouseenter(function () {
      $(this).addClass("MajorColor").siblings().removeClass("MajorColor");
      $(this).find($('.MajorBottom')).addClass("MajorShow");
      $(this).siblings().find($('.MajorBottom')).removeClass("MajorShow");
    })
  },

  // News滑入
  NewsShow: function () {
    $('.NewsTop').mouseenter(function () {
      $(this).addClass("NewsColor").siblings().removeClass("NewsColor");
      $(this).find($('.NewsBottom')).addClass("NewsShow");
      $(this).siblings().find($('.NewsBottom')).removeClass("NewsShow");
    })
  },

  // 四大专业学生作品动画效果
  WorksShow: function () {
    $('.WorkImg').mouseenter(function () {
      $(this).addClass('WorksImg').siblings().removeClass('WorksImg');
    })
    $('.WorkImg').mouseleave(function () {
      $(this).removeClass('WorksImg');
    })
  },

  //师资力量头部按钮滑过
  Power: function () {
    $('.ContentSpan').mouseenter(function () {
      $(this).addClass('PowerShow').siblings().removeClass('PowerShow')
    })
  },

  //师资力量头部按钮滑点击
  PowerClick: function () {
    $('#xd').click(function () {
      window.scrollTo({ left: 0, top: 1330, behavior: "smooth" })
    });
    $('#xc').click(function () {
      window.scrollTo({ left: 0, top: 2860, behavior: "smooth" })
    });
    $('#kf').click(function () {
      window.scrollTo({ left: 0, top: 4520, behavior: "smooth" })
    });
    $('#tj').click(function () {
      window.scrollTo({ left: 0, top: 6060, behavior: "smooth" })
    })
  },

  // 师资力量导师介绍
  TeacherShow: function () {
    $(".ContentImg").mouseenter(function () {
      $(this).css({ "box-shadow": "0 0 10px #ccc" });
      $(this)
        .find($(".ContentSpan"))
        .css({ top: "300px", height: "210px" });
    });
    $(".ContentImg").mouseleave(function () {
      $(this).css({ "box-shadow": "none" });
      $(this)
        .find($(".ContentSpan"))
        .css({ top: "376px", height: "130px" });
    });
  },

  //学生作品头部按钮滑点击
  StudentClick: function () {
    $('#xd').click(function () {
      window.scrollTo({ left: 0, top: 1050, behavior: "smooth" })
    });
    $('#xc').click(function () {
      window.scrollTo({ left: 0, top: 2600, behavior: "smooth" })
    });
    $('#kf').click(function () {
      window.scrollTo({ left: 0, top: 3920, behavior: "smooth" })
    });
    $('#tj').click(function () {
      window.scrollTo({ left: 0, top: 5475, behavior: "smooth" })
    })
  },


  //西餐15个月按钮点击切换
  FifteenClick: function () {
    $('.cjy_click').click(function () {
      $(this).removeClass('cjy_NoChange').addClass('cjy_Change');
      $(this).siblings().removeClass('cjy_Change').addClass('cjy_NoChange');
    });
    $('.cjy_clickLeft').click(function () {
      $('.cjy_spanLeft').removeClass('cjy_none');
      $('.cjy_spanRight').addClass('cjy_none');
    });
    $('.cjy_clickRight').click(function () {
      $('.cjy_spanRight').removeClass('cjy_none');
      $('.cjy_spanLeft').addClass('cjy_none');
    });
  },




  // 弹窗点击消失后循环
  popupNone: function () {
    let that = this
    $('#popupNone').on('click', function () {
      $('.popup').css('display', 'none'),
        that.popup()
    })
  },

  // 弹窗弹出
  popup: function () {
    $(document).ready(function () {
      setTimeout(function () {
        $('.popup').css('display', 'block')
      }, 20000)
    })
  },

  // 创就业按钮
  Cjy: function () {
    $('.buttonRouter').on('click', function () {
      $(this).addClass('color'),
        $(this).parent().siblings().find('.buttonRouter').removeClass('color');
    })
  },


  // 底部axios
  axios: function () {
    // const axios = require('axios');
    $('.BottomHref').click(function () {
      var name = $('#f_xm').val();
      var tel = $('#f_tel').val();
      var zy = $('#f_zy').val();
      var xq = $('#f_xq').val();
      console.log(zy)
      if (name == '') {
        alert("姓名不能为空！");
        return false;
      }
      if (tel == '' || tel.length < 11 || tel.length > 11 || isNaN(tel)) {
        alert("请输入11位正确号码！");
        return false;
      }
      var user = {
        b_xm: name,
        b_tel: tel,
        b_zy: zy,
        b_qq: xq,
        b_url1: decodeURIComponent(window.location.href),
        b_url2: document.referrer
      }
      $.ajax({
        url: "http://www.gsomick.cn/plus/diy3.php?action=post&diyid=1",
        type: "POST",
        data: user,
        dataType: "json",
        contentType: "application/x-www-form-urlencoded; charset=utf-8",
        success: function (data) {
          alert('提交成功！将有专属老师与您联系发送课程报价');
        }
      });
    })
  },

  // 弹窗axios
  popupAxios: function () {
    // const axios = require('axios');
    $('.popupHref').click(function () {
      var name = $('#popup_xm').val();
      var tel = $('#popup_tel').val();
      var zy = $('#popup_zy input:checkbox').val();
      console.log(zy)
      if (name == '') {
        alert("姓名不能为空！");
        return false;
      }
      if (tel == '' || tel.length < 11 || tel.length > 11 || isNaN(tel)) {
        alert("请输入11位正确号码！");
        return false;
      }
      var user = {
        b_xm: name,
        b_tel: tel,
        b_zy: zy,
        b_url1: decodeURIComponent(window.location.href),
        b_url2: decodeURIComponent(window.location.href),
        // b_url2: document.referrer
      }
      $.ajax({
        url: "http://www.gsomick.cn/plus/diy3.php?action=post&diyid=1",
        type: "POST",
        data: user,
        dataType: "json",
        contentType: "application/x-www-form-urlencoded; charset=utf-8",
        success: function (data) {
          alert('提交成功！将有专属老师与您联系发送课程报价');
        }
      });
    })
  },

  // 通栏广告Aaxios
  BillboardAAxios: function () {
    // const axios = require('axios');
    $('.BillboardA a').click(function () {
      var tel = $('#BillboardA_tel').val();
      if (tel == '' || tel.length < 11 || tel.length > 11 || isNaN(tel)) {
        alert("请输入11位正确号码！");
        return false;
      }
      var user = {
        b_tel: tel,
        b_url1: decodeURIComponent(window.location.href),
        b_url2: document.referrer
      }
      $.ajax({
        url: "http://www.gsomick.cn/plus/diy3.php?action=post&diyid=1",
        type: "POST",
        data: user,
        dataType: "json",
        contentType: "application/x-www-form-urlencoded; charset=utf-8",
        success: function (data) {
          alert('提交成功！将有专属老师与您联系发送课程报价');
        }
      });
    })
  },

  // 通栏广告Baxios
  BillboardBAxios: function () {
    // const axios = require('axios');
    $('.BillboardB a').click(function () {
      var name = $('#BillboardB_xm').val();
      var tel = $('#BillboardB_tel').val();
      if (name == '') {
        alert("姓名不能为空！");
        return false;
      }
      if (tel == '' || tel.length < 11 || tel.length > 11 || isNaN(tel)) {
        alert("请输入11位正确号码！");
        return false;
      }
      var user = {
        b_xm: name,
        b_tel: tel,
        b_url1: decodeURIComponent(window.location.href),
        b_url2: document.referrer
      }
      $.ajax({
        url: "http://www.gsomick.cn/plus/diy3.php?action=post&diyid=1",
        type: "POST",
        data: user,
        dataType: "json",
        contentType: "application/x-www-form-urlencoded; charset=utf-8",
        success: function (data) {
          alert('提交成功！将有专属老师与您联系发送课程报价');
        }
      });
    })
  },

  /**
   *
   *  c 公司ID
      g 客服分组ID
      n 客服ID
      v 访客本次标识
      u 访客唯一标识
      config 嵌入代码ID
      ext 扩展字段 格式"#params:key1,value1,key2,value2..."
      first 首次访问页面
      ref 来源页面
      chatUrl 对话地址
      promotionId 渠道ID
   */
  writeYLScript(c = '13020', config = "") {
    document.write(`<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/${c}/${config}.js'></script>`);
  },
  linkYL(c = '13020', g = '', config = "", ref = "", chatUrl = "", first = "") {
    location.href = `http://live.easyliao.com/live/chat.do?c=${c}&g=${g}&config=${config}&chatUrl=${chatUrl}&first=${first}`;
    // location.href = `http://live.easyliao.com/live/chat.do?c=${c}&g=${g}&config=${config}&ref=${ref}&chatUrl=${chatUrl}&first=${first}`;
  },

  panduan: function () {
    //先引入易聊公共js
    document.write("<script src='//scripts.easyliao.com/js/easyliao.js'></script>");
    //判断域名
    var domain = window.location.host;
    // 新疆
    if (domain == 'www.xhomick.com') {
      this.writeYLScript('13020', '35983') // c=13020&g=24368&config=35983&ref=xj&chatUrl=http://www.xhomick.com/&first=http://www.xhomick.cn/
      /* document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35983.js'></script>"); */
    } else if (domain == 'szpc.xhomick.com') {
      this.writeYLScript('13020', '35979')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35979.js'></script>");
    } else if (domain == 'szpc.xhomick.cn' || domain == 'www.gdomick.cn' || domain == 'www.gdomick.com' || domain == 'www.gdszomick.cn' || domain == 'www.gdszomick.com' || domain == 'www.szomq.cn') {
      this.writeYLScript('13020', '35979')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35979.js'></script>");
    } else if (domain == 'hnpc.xhomick.com') {
      this.writeYLScript('13020', '35981')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35981.js'></script>");
    } else if (domain == 'hnpc.xhomick.cn') {
      this.writeYLScript('13020', '35981')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35981.js'></script>");
    } else if (domain == 'ycpc.xhomick.com') {
      this.writeYLScript('13020', '35561')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35561.js'></script>");
    } else if (domain == 'ycpc.xhomick.cn') {
      this.writeYLScript('13020', '35561')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/35561.js'></script>");
    } else if (domain == 'www.gyomick.com') {
      this.writeYLScript('13020', '36316')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/36316.js'></script>");
    } else if (domain == 'www.gzomiqi.com') {
      this.writeYLScript('13020', '36316')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/36316.js'></script>");
    } else if (domain == 'www.ynomick.com') {
      this.writeYLScript('13020', '36623')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/36623.js'></script>");
    } else if (domain == 'www.ynomick.cn') {
      this.writeYLScript('13020', '36623')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/36623.js'></script>");
    } else if (domain == 'www.cqomick.com') {
      this.writeYLScript('13020', '36640')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/36640.js'></script>");
    } else if (domain == 'www.nmgomick.com') {
      this.writeYLScript('13020', '43325')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/43325.js'></script>");
    } else if (domain == 'dgpc.cqomick.com') {
      this.writeYLScript('13020', '112734')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/43774.js'></script>");
    } else if (domain == 'dgpc.xhomick.com') {
      this.writeYLScript('13020', '43774')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/43774.js'></script>");
    }
    else if (domain == 'dgpc.xhomick.cn') {
      this.writeYLScript('13020', '43774')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/43774.js'></script>");
    }

    else if (domain == 'cspc.xhomick.com') {
      this.writeYLScript('13020', '43956')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/43956.js'></script>");
    } else if (domain == 'cspc.cqomick.com') {
      this.writeYLScript('13020', '43956')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/43956.js'></script>");
    } else if (domain == 'lypc.xhomick.com') {
      this.writeYLScript('13020', '44762')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/44762.js'></script>");
    } else if (domain == 'mypc.xhomick.com') {
      this.writeYLScript('13020', '46497')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/46497.js'></script>");
    } else if (domain == 'hbpc.xhomick.com' || domain == 'hbpc.xhomick.cn') {
      this.writeYLScript('13020', '49804')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/49804.js'></script>");
    }
    else if (domain == 'stpc.xhomick.com') {
      this.writeYLScript('13020', '58656')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/49804.js'></script>");
    }
    else if (domain == 'www.tsomick.com') {
      this.writeYLScript('13020', '64068')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/49804.js'></script>");
    }
    else if (domain == 'www.dgomick.com') {
      this.writeYLScript('13020', '43774')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/49804.js'></script>");
    }
    else if (domain == 'www.dgomick.cn') {
      this.writeYLScript('13020', '43774')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/49804.js'></script>");
    }
    else if (domain == 'sqpc.xhomick.com') {
      this.writeYLScript('13020', '66484')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/49804.js'></script>");
    }
    else if (domain == 'sqpc.xhomick.cn') {
      this.writeYLScript('13020', '66484')
      // document.write("<script type='text/javascript' charset='UTF-8' src='//scripts.easyliao.com/13020/66484.js'></script>");
    }
    else if (domain == 'www.csomick.com'|| domain == 'www.csomick.cn') {
      this.writeYLScript('13020', '46899')
    }
    else if (domain == 'www.ccomick.com'||domain == 'www.ccomick.cn') {
      this.writeYLScript('13020', '113288')
    }
    else if (domain == 'www.tyomick.com') {
      this.writeYLScript('13020', '100955')
    }
    else if (domain == 'www.xmomick.com'|| domain == 'www.xmomick.cn') {
      this.writeYLScript('13020', '113287')
    }
    else {
      this.writeYLScript('13020', '35983');
    }

    let that = this;
    $('.YL').on('click', function () {
      if (domain == 'www.xhomick.com') {
        that.linkYL('13020', '24368', '35983', 'xj', 'http://www.xhomick.com/', 'http://www.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24368&config=35983&ref=xj&chatUrl=http://www.xhomick.com/&first=http://www.xhomick.cn/';
      } else if (domain == 'www.xhomick.cn') {
        that.linkYL('13020', '24368', '35983', 'xj', 'http://www.xhomick.cn/', 'http://www.xhomick.cn/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24368&config=35983&ref=xj&chatUrl=xj&first=xj';
      } else if (domain == 'szpc.xhomick.com' || domain == 'szpc.xhomick.cn' || domain == 'www.gdomick.cn' || domain == 'www.gdomick.com' || domain == 'www.gdszomick.cn' || domain == 'www.gdszomick.com' || domain == 'www.szomq.cn') {
        that.linkYL('13020', '24561', '35979', 'sz', 'http://szpc.xhomick.com/', 'http://szpc.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24561&config=35979&ref=sz&chatUrl=sz&first=sz';
      } else if (domain == 'hnpc.xhomick.com') {
        that.linkYL('13020', '24991', '35981', 'hn', 'http://hnpc.xhomick.com/', 'http://hnpc.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24991&config=35981&ref=hn&chatUrl=hn&first=hn';
      } else if (domain == 'hnpc.xhomick.cn') {
        that.linkYL('13020', '24991', '35981', 'hn', 'http://hnpc.xhomick.cn/', 'http://hnpc.xhomick.cn/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24991&config=35981&ref=hn&chatUrl=hn&first=hn';
      } else if (domain == 'ycpc.xhomick.com') {
        that.linkYL('13020', '24560', '35561', 'yc', 'http://ycpc.xhomick.com/', 'http://ycpc.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24560&config=35561&ref=yc&chatUrl=yc&first=yc';
      } else if (domain == 'ycpc.xhomick.cn') {
        that.linkYL('13020', '24560', '35561', 'yc', 'http://ycpc.xhomick.cn/', 'http://ycpc.xhomick.cn/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24560&config=35561&ref=yc&chatUrl=yc&first=yc';
      } else if (domain == 'www.gyomick.com') {
        that.linkYL('13020', '24992', '36316', 'gy', 'http://www.gyomick.com/', 'http://www.gyomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24992&config=36316&ref=gy&chatUrl=gy&first=gy';
      } else if (domain == 'www.gzomiqi.com') {
        that.linkYL('13020', '24992', '36316', 'gy', 'http://www.gzomiqi.com/', 'http://www.gzomiqi.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24992&config=36316&ref=gy&chatUrl=gy&first=gy';
      } else if (domain == 'www.ynomick.com') {
        that.linkYL('13020', '24999', '36623', 'km', 'http://www.ynomick.com/', 'http://www.ynomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24999&config=36623&ref=km&chatUrl=km&first=km';
      } else if (domain == 'www.ynomick.cn') {
        that.linkYL('13020', '24999', '36623', 'km', 'http://www.ynomick.cn/', 'http://www.ynomick.cn/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24999&config=36623&ref=km&chatUrl=km&first=km';
      } else if (domain == 'www.cqomick.com') {
        that.linkYL('13020', '24994', '36640', 'cq', 'http://www.cqomick.com/', 'http://www.cqomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=24994&config=36640&ref=cq&chatUrl=cq&first=cq';
      } else if (domain == 'www.nmgomick.com') {
        that.linkYL('13020', '28098', '43325', 'cq', 'http://www.nmgomick.com/', 'http://www.nmgomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=28098&config=43325&ref=cq&chatUrl=cq&first=cq';
      } else if (domain == 'dgpc.cqomick.com') {
        that.linkYL('13020', '82896', '112734', 'dg', 'http://dgpc.cqomick.com/', 'http://dgpc.cqomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=28376&config=43774&ref=dg&chatUrl=dg&first=dg';
      } else if (domain == 'dgpc.xhomick.com') {
        that.linkYL('13020', '28376', '43774', 'dg', 'http://dgpc.xhomick.com/', 'http://dgpc.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=28376&config=43774&ref=dg&chatUrl=dg&first=dg';
      }else if (domain == 'dgpc.xhomick.cn') {
        that.linkYL('13020', '28376', '43774', 'dg', 'http://dgpc.xhomick.cn/', 'http://dgpc.xhomick.cn/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=28376&config=43774&ref=dg&chatUrl=dg&first=dg';
      }
      else if (domain == 'cspc.xhomick.com') {
        that.linkYL('13020', '28549', '43956', 'cz', 'http://cspc.xhomick.com/', 'http://cspc.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=28549&config=43956&ref=cz&chatUrl=cz&first=cz';
      } else if (domain == 'cspc.cqomick.com') {
        that.linkYL('13020', '28549', '43956', 'cz', 'http://cspc.cqomick.com/', 'http://cspc.cqomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=28549&config=43956&ref=cz&chatUrl=cz&first=cz';
      } else if (domain == 'lypc.xhomick.com') {
        that.linkYL('13020', '29006', '44762', 'ly', 'http://lypc.xhomick.com/', 'http://lypc.xhomick.com/');
        // location.href = 'http://live.easyliao.com/live/chat.do?c=13020&g=29006&config=44762&ref=ly&chatUrl=ly&first=ly';
      } else if (domain == 'mypc.xhomick.com') {
        that.linkYL('13020', '29890', '46496', 'my', 'http://mypc.xhomick.com/', 'http://mypc.xhomick.com/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=29890&config=46496&ref=my&chatUrl=my&first=my';
      } else if (domain == 'hbpc.xhomick.com' || domain == 'hbpc.xhomick.cn') {
        that.linkYL('13020', '31483', '49804', 'hbyc', 'http://hbpc.xhomick.com/', 'http://hbpc.xhomick.com/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=31483&config=49804&ref=hbyc&chatUrl=hbyc&first=hbyc';
      }
      else if (domain == 'stpc.xhomick.com') {
        that.linkYL('13020', '31483', '49804', 'stpc', 'http://stpc.xhomick.com/', 'http://stpc.xhomick.com/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=31483&config=49804&ref=stpc&chatUrl=stpc&first=stpc';
      }
      else if (domain == 'www.tsomick.com') {
        that.linkYL('13020', '41162', '64068', 'ts', 'www.tsomick.com/', 'www.tsomick.com/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=31483&config=49804&ref=stpc&chatUrl=stpc&first=stpc';
      }
      else if (domain == 'www.tsomick.cn') {
        that.linkYL('13020', '41162', '64068', 'ts', 'www.tsomick.cn/', 'www.tsomick.cn/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=31483&config=49804&ref=stpc&chatUrl=stpc&first=stpc';
      }
      else if (domain == 'www.dgomick.com') {
        that.linkYL('13020', '28376', '43774', 'dg', 'www.dgomick.com/', 'www.dgomick.com/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=31483&config=49804&ref=stpc&chatUrl=stpc&first=stpc';
      }
      else if (domain == 'www.dgomick.cn') {
        that.linkYL('13020', '28376', '43774', 'dg', 'www.dgomick.cn/', 'www.dgomick.cn/');
        // location.href = 'http://prd5.easyliao.com/live/chat.do?c=13020&g=31483&config=49804&ref=stpc&chatUrl=stpc&first=stpc';
      }
      else if (domain == 'sqpc.xhomick.com') {
           that.linkYL('13020', '43357', '66484', 'sqpc', 'http://sqpc.xhomick.com/', 'http://sqpc.xhomick.com/');
      }
      else if (domain == 'sqpc.xhomick.cn') {
        that.linkYL('13020', '43357', '66484', 'sqpc', 'http://sqpc.xhomick.cn/', 'http://sqpc.xhomick.cn/');
      }
      else if (domain == 'www.csomick.com'|| domain == 'www.csomick.cn') {
        that.linkYL('13020', '30122', '46899', 'cs', 'http://www.csomick.com/', 'http://www.csomick.com/');
      }
      else if (domain == 'www.ccomick.com') {
        that.linkYL('13020', '83551', '113288', 'cs', 'http://www.ccomick.com/', 'http://www.ccomick.com/');
      }
      else if (domain == 'www.ccomick.cn') {
        that.linkYL('13020', '83551', '113288', 'cs', 'http://www.ccomick.cn/', 'http://www.ccomick.cn/');
      }
      else if (domain == 'www.tyomick.com') {
        that.linkYL('13020', '24927', '100955', 'cs', 'http://www.tyomick.com/', 'http://www.tyomick.com/');
      }
      else if (domain == 'www.xmomick.com'||domain == 'www.xmomick.cn') {
        that.linkYL('13020', '83549', '113287', 'cs', 'http://www.xmomick.com/', 'http://www.xmomick.com/');
      }
       else {
       that.linkYL('13020', '24368', '35983', 'xj', 'http://www.xhomick.com/', 'http://www.xhomick.com/');
       }
    })
  },

  // Tj:function(){
  //     var bdtj = window.location.host;
  //     if(bdtj == 'www.xhomick.com' || bdtj == 'www.xhomick.cn'){
  //         document.writeln("<script src='/public/js/XJwww.js'></script>");
  //     }else if(bdtj == 'szpc.xhomick.com' || bdtj == 'szpc.xhomick.cn'){
  //         document.writeln("<script src='/public/js/SZwww.js'></script>");
  //     }else if(bdtj == 'hnpc.xhomick.com' || bdtj == 'hnpc.xhomick.cn'){
  //         document.writeln("<script src='/public/js/HNwww.js'></script>");
  //     }else if(bdtj == 'ycpc.xhomick.com' || bdtj == 'ycpc.xhomick.cn'){
  //         document.writeln("<script src='/public/js/YCwww.js'></script>");
  //     }else if(bdtj == 'www.gyomick.com'){
  //         document.writeln("<script src='/public/js/GYwww.js'></script>");
  //     }else if(bdtj == 'www.ynomick.com' || bdtj == 'www.ynomick.cn'){
  //         document.writeln("<script src='/public/js/YNwww.js'></script>");
  //     }else if(bdtj == 'www.cqomick.com'){
  //         document.writeln("<script src='/public/js/CQwww.js'></script>");
  //     }else if(bdtj == 'www.nmgomick.com'){
  //         document.writeln("<script src='/public/js/NMGwww.js'></script>");
  //     }else if(bdtj == 'dgpc.xhomick.com'){
  //         document.writeln("<script src='/public/js/DGwww.js'></script>");
  //     }
  // }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js